import axios from './axios';

// There is intentionally no "list all patients" helper here. The old one
// loaded the first ~1000 patients (oldest first) and filtered them in the
// browser, which hid every patient past the cap. Use searchPatients().

/**
 * Server-side patient search + paging. Use this for anything that lists
 * patients.
 *
 * Resolves to the axios response; `data.data` is `{ items, total }`.
 */
export const searchPatients = ({
	search = '',
	limit = 10,
	offset = 0,
	sortField = 'id',
	sortDirection = 'asc',
} = {}, config) => axios.post('/api/Patients/Search', {
	search,
	limit,
	offset,
	sortField,
	sortDirection,
}, config);

export const createPatient = (patient) => axios.post('/api/Patients/Add', patient);
export const updatePatient = (patient) => axios.post('/api/Patients/Update', patient);
/**
 * Soft-deletes a patient (requires patient:delete). The server audits it with
 * the signed-in user and the reason, so always pass one.
 */
export const deletePatient = (patientId, reason) =>
	axios.delete('/api/Patients', { params: { id: patientId, reason } });
export const getPatientById = (patientId) => axios.get('/api/Patients/' + patientId);

export const getPatientHistory = (patientId) => axios.get(`/api/AnswerReport/GetHistoryList?request=${patientId}`);
